import colors from './colors'
import buttons from './buttons'

import './Styles/fonts.css'

import baseTheme from '../baseTheme'

const theme = {
  ...baseTheme,

  name: 'Alternative theme',

  colors,

  buttons,
}

export default theme
